// extracted by mini-css-extract-plugin
export default {"mintButton":"WhitelistSale_mintButton__yixHM"};